import { render } from "./RedirectPreferredDate.vue?vue&type=template&id=6925c98d"
import script from "./RedirectPreferredDate.vue?vue&type=script&lang=js"
export * from "./RedirectPreferredDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__